// Anita Week 10 / Day 5 — Final Gate: Light of the Author.
// Verbatim from FINAL Week 10 Part B (Final Quest) source-of-truth package.
// Completing this day unlocks Nimny Night Runner for Anita.

const day5 = {
  id: 'day-5',
  studentId: 'anita',
  weekId: 'week-10',
  dayId: 'day-5',
  status: 'active',
  title: 'Финальные ворота: огонёк автора / Final Gate: Light of the Author',
  shortTitle: 'Финальные ворота / Final Gate',
  theme: 'Анита собирает последние огоньки: проверять, выбирать, объяснять и делать полезное. / Anita collects the final lights: check, choose, explain and make something useful.',
  estimatedTimeLabel: '60–90 минут / 60–90 minutes',
  lessonTiming: { minMinutes: 60, maxMinutes: 90, breaks: 2 },
  bilingualMode: 'ru-primary-en-helper',
  readingLevel: 'grade-2',
  courseLayers: ['reading', 'math', 'quest', 'review', 'author', 'project', 'spelling', 'speech'],
  questMode: true,
  questLight: 'final-author-gate',
  completesWeek: true,
  completionUnlocks: { type: 'game', route: 'nimny-night-run' },
  questMeta: { lightId: 'author-light', lightNameRu: 'Огонёк автора', lightNameEn: 'Light of the Author', questNode: 5, passportStamp: 'финальные-ворота' },
  nimnyIntro:
    'Нимни стоит перед финальными воротами. За ними — ночная игра. Чтобы открыть ворота, Анита собирает последний огонёк: огонёк автора. Она вспоминает, как выбирать, проверять, планировать, объяснять и делать полезное. Это не экзамен. Это праздник пути. / Nimny stands before the final gate. Behind it is the night game. To open the gate, Anita collects the last light: the light of the author. She reviews how to choose, check, plan, explain and make something useful. This is not an exam. It is a celebration of the journey.',
  goals: [
    'Повторить главные огоньки курса. / Review the main course lights.',
    'Связать выбор, безопасность, исследование, карту и авторство. / Connect choice, safety, research, map and authorship.',
    'Решить лёгкие квестовые задачи. / Solve light quest tasks.',
    'Заполнить финальный паспорт квеста. / Fill the final quest passport.',
    'Сказать финальное обещание автора. / Say the final author promise.',
    'Открыть ночную игру после завершения. / Unlock the night game after completion.'
  ],
  vocabulary: [
    { term: 'выбор / choice', definition: 'когда я сравниваю и решаю. / when I compare and decide.' },
    { term: 'безопасность / safety', definition: 'когда я знаю, что делать. / when I know what to do.' },
    { term: 'исследователь / researcher', definition: 'тот, кто наблюдает, измеряет и делает вывод. / one who observes, measures and concludes.' },
    { term: 'карта / map', definition: 'помогает найти путь. / helps find a path.' },
    { term: 'план / plan', definition: 'шаги к цели. / steps to a goal.' },
    { term: 'информация / information', definition: 'сообщение, которое можно понять и проверить. / a message that can be understood and verified.' },
    { term: 'польза / value', definition: 'как идея помогает человеку. / how an idea helps a person.' },
    { term: 'автор / author', definition: 'тот, кто делает полезный материал. / one who creates useful material.' },
    { term: 'памятка / guide card', definition: 'короткая полезная подсказка. / a short useful card.' },
    { term: 'ворота / gate', definition: 'финальная точка квеста. / the final point of the quest.' }
  ],
  onlineTasks: [
    { id: 'reading-review-words', type: 'text', title: 'Задание 1 — Слова финальных ворот / Final Gate Words',
      prompt: 'Прочитай слова:\n\nвыбор\nбезопасность\nисследователь\nкарта\nплан\nинформация\nпольза\nавтор\nпамятка\nворота',
      ruPrimaryText: 'Прочитай 10 русских слов финальных ворот.',
      enHelpText: 'Read the Russian final gate words first. English is only for help.',
      answer: 'Attempted Russian reading.' },
    { id: 'final-gate-reading', type: 'text', title: 'Задание 2 — Фразы финальных ворот / Final Gate Phrases',
      prompt: 'Прочитай по-русски:\n\nЯ умею выбирать.\nЯ умею проверять.\nЯ умею просить помощи.\nЯ умею делать вывод.\nЯ могу быть автором полезного материала.',
      ruPrimaryText: 'Прочитай 5 финальных фраз.',
      enHelpText: 'I can choose. I can check. I can ask for help. I can make a conclusion. I can be the author of useful material.',
      answer: 'Attempted Russian reading.' },
    { id: 'final-light-match', type: 'text', title: 'Задание 3 — Собери огоньки / Match the Lights',
      prompt: 'Соедини огонёк и тему.\n\n1. Огонёк выбора\n2. Огонёк безопасности\n3. Огонёк исследователя\n4. Огонёк карты и плана\n5. Огонёк автора\n\nA. Я измеряю, наблюдаю и делаю вывод.\nB. Я создаю полезный материал.\nC. Я сравниваю «нужно», «хочу» и «полезно».\nD. Я знаю: стоп, проверить, рассказать.\nE. Я читаю карту, маршрут и время.',
      ruPrimaryText: 'Соедини 5 огоньков и 5 тем.',
      enHelpText: 'Match 5 lights with 5 themes.',
      answer: '1-C; 2-D; 3-A; 4-E; 5-B.' },
    { id: 'math-final-lights', type: 'text', title: 'Задание 4 — Математика огоньков / Light Math',
      prompt: 'У Нимни 5 огоньков.\nВ каждом огоньке по 4 искры.\n\nПотом Нимни добавила 3 печати, в каждой по 2 звёздочки.\n\nОтветь:\n1. Сколько искр в 5 огоньках?\n2. Сколько звёздочек в 3 печатях?\n3. Сколько всего искр и звёздочек?\n4. Если 24 звёздочки разделить на 6 кармашков паспорта, сколько будет в каждом?',
      ruPrimaryText: 'Реши 4 задачи про огоньки и звёздочки.',
      enHelpText: 'Solve 4 light-math tasks.',
      answer: '1) 5 × 4 = 20. 2) 3 × 2 = 6. 3) 20 + 6 = 26. 4) 24 ÷ 6 = 4.' },
    { id: 'math-final-time', type: 'text', title: 'Задание 5 — Время финального квеста / Final Quest Time',
      prompt: 'Финальный квест состоит из 4 коротких частей:\n\n1. Прочитать фразы — 8 минут.\n2. Собрать огоньки — 12 минут.\n3. Заполнить паспорт — 15 минут.\n4. Объяснить родителю — 10 минут.\n\nОтветь:\n1. Сколько минут займут первые две части?\n2. Сколько минут займёт весь квест?\n3. Если есть 60 минут, сколько минут останется?\n4. Если Анита сделала первые 3 части, сколько минут осталось до конца?',
      ruPrimaryText: 'Реши 4 задачи про время финального квеста.',
      enHelpText: 'Solve 4 final-quest time tasks.',
      answer: '1) 8 + 12 = 20. 2) 8 + 12 + 15 + 10 = 45. 3) 60 − 45 = 15. 4) 10 минут.' },
    { id: 'final-safety-author-sort', type: 'classify', title: 'Задание 6 — Что можно в финальном проекте? / Final Project Safety',
      prompt: 'Разложи карточки.\n\nКатегории:\nМожно использовать\nНужно спросить родителя\nНельзя использовать\n\nКарточки:\n1. Нарисовать вымышленную карту Нимни.\n2. Написать настоящий домашний адрес.\n3. Сделать памятку «как попросить помощи».\n4. Ввести пароль в ИИ.\n5. Показать родителю черновик.\n6. Написать название школы.\n7. Сделать постер «стоп — уйти — рассказать».\n8. Попросить родителя помочь проверить.\n9. Публиковать проект онлайн без взрослого.\n10. Использовать роли: родитель, учитель, работник места.\n11. Нарисовать огонёк знаний.\n12. Добавить фото ребёнка.',
      ruPrimaryText: 'Разложи 12 карточек: можно / спросить родителя / нельзя.',
      enHelpText: 'Sort 12 cards: allowed / ask parent / not allowed.',
      categories: [
        { id: 'allowed', label: 'Можно использовать / Allowed' },
        { id: 'parent', label: 'Нужно спросить родителя / Ask parent first' },
        { id: 'forbidden', label: 'Нельзя использовать / Not allowed' }
      ],
      items: [
        { id: 'f1', label: '1. Нарисовать вымышленную карту Нимни.', category: 'allowed' },
        { id: 'f2', label: '2. Написать настоящий домашний адрес.', category: 'forbidden' },
        { id: 'f3', label: '3. Сделать памятку «как попросить помощи».', category: 'allowed' },
        { id: 'f4', label: '4. Ввести пароль в ИИ.', category: 'forbidden' },
        { id: 'f5', label: '5. Показать родителю черновик.', category: 'parent' },
        { id: 'f6', label: '6. Написать название школы.', category: 'forbidden' },
        { id: 'f7', label: '7. Сделать постер «стоп — уйти — рассказать».', category: 'allowed' },
        { id: 'f8', label: '8. Попросить родителя помочь проверить.', category: 'parent' },
        { id: 'f9', label: '9. Публиковать проект онлайн без взрослого.', category: 'forbidden' },
        { id: 'f10', label: '10. Использовать роли: родитель, учитель, работник места.', category: 'allowed' },
        { id: 'f11', label: '11. Нарисовать огонёк знаний.', category: 'allowed' },
        { id: 'f12', label: '12. Добавить фото ребёнка.', category: 'forbidden' }
      ],
      answer: 'Можно: 1, 3, 7, 10, 11. Спросить родителя: 5, 8. Нельзя: 2, 4, 6, 9, 12.' },
    { id: 'final-quest-passport', type: 'project', title: 'Задание 7 — Финальный паспорт квеста / Final Quest Passport',
      prompt: 'Заполни финальный паспорт квеста.\n\nВ паспорте 5 печатей:\n\n1. Огонёк выбора — я умею ______.\n2. Огонёк безопасности — я знаю ______.\n3. Огонёк исследователя — я могу ______.\n4. Огонёк карты и плана — я умею ______.\n5. Огонёк автора — я могу ______.\n\nНарисуй рядом маленький огонёк.',
      ruPrimaryText: 'Заполни 5 печатей паспорта и нарисуй маленький огонёк.',
      enHelpText: 'Fill in 5 passport stamp sentences and draw a small light.',
      answer: 'Open-ended. Accept if Anita completes most sentence stems and draws a light.' },
    { id: 'spelling-final-gate', type: 'text', title: 'Задание 8 — Правописание / Spelling',
      prompt: 'Напиши 6 слов на выбор:\n\nвыбор\nкарта\nплан\nавтор\nпольза\nвывод\nворота\nпомощь\nогонёк\nпамятка',
      ruPrimaryText: 'Напиши любые 6 слов из списка.',
      enHelpText: 'Write any 6 words from the list.',
      answer: 'Any 6 attempted words. Parent checks gently.' },
    { id: 'speech-final-gate', type: 'text', title: 'Задание 9 — Финальные слова / Final Words',
      prompt: 'Скажи родителю по-русски:\n\nЯ умею выбирать.\nЯ умею проверять.\nЯ умею просить помощи.\nЯ умею делать вывод.\nЯ могу сделать полезный материал.',
      ruPrimaryText: 'Скажи родителю минимум 3 финальные фразы.',
      enHelpText: 'Tell parent at least 3 final phrases.',
      answer: 'Accept if Anita says most final phrases in Russian with support.' },
    { id: 'final-author-promise', type: 'text', title: 'Задание 10 — Обещание автора / Author Promise',
      prompt: 'Прочитай и скажи:\n\nЯ не только смотрю.\nЯ думаю, проверяю и создаю полезное.\nЯ не пишу личные данные онлайн.\nЯ показываю важное родителю.\nЯ могу сделать хороший шаг сама.',
      ruPrimaryText: 'Скажи обещание автора по-русски.',
      enHelpText: 'Say the author promise in Russian.',
      answer: 'Accept if Anita reads or repeats the promise with parent support.' }
  ],
  notebookInstructions: [
    'Если нет принтера:',
    '1. Напиши слова финальных ворот.',
    '2. Прочитай 5 фраз.',
    '3. Соедини 5 огоньков с темами.',
    '4. Реши задачи про огоньки и время.',
    '5. Разложи карточки безопасности устно с родителем.',
    '6. Заполни финальный паспорт в тетради.',
    '7. Напиши 6 слов.',
    '8. Скажи финальные слова и обещание автора.'
  ],
  printWorksheet: {
    title: 'Финальные ворота: огонёк автора / Final Gate: Light of the Author',
    subtitle: 'Неделя 10 · День 5 / Week 10 · Day 5 · Final Passport',
    pages: [
      { title: 'Финальные ворота / Final Gate',
        blocks: [
          { type: 'text', text: 'Имя: __________________________   Дата: __________________________' },
          { type: 'text', text: 'Миссия: Нимни стоит перед финальными воротами. Сегодня ты собираешь последние огоньки и открываешь путь к ночной игре.' },
          { type: 'text', text: 'Задание 1 — Слова финальных ворот. Прочитай и обведи:' },
          { type: 'list', items: [
            'выбор / choice',
            'безопасность / safety',
            'исследователь / researcher',
            'карта / map',
            'план / plan',
            'информация / information',
            'польза / value',
            'автор / author',
            'памятка / guide card',
            'ворота / gate'
          ] },
          { type: 'text', text: 'Задание 2 — Фразы финальных ворот. Поставь галочку:' },
          { type: 'list', items: [
            '□ Я умею выбирать.',
            '□ Я умею проверять.',
            '□ Я умею просить помощи.',
            '□ Я умею делать вывод.',
            '□ Я могу быть автором полезного материала.'
          ] },
          { type: 'text', text: 'Задание 3 — Собери огоньки. Соедини огонёк и тему.' },
          { type: 'list', items: [
            '1. Огонёк выбора → ______',
            '2. Огонёк безопасности → ______',
            '3. Огонёк исследователя → ______',
            '4. Огонёк карты и плана → ______',
            '5. Огонёк автора → ______'
          ] },
          { type: 'list', items: [
            'A. Я измеряю, наблюдаю и делаю вывод.',
            'B. Я создаю полезный материал.',
            'C. Я сравниваю «нужно», «хочу» и «полезно».',
            'D. Я знаю: стоп, проверить, рассказать.',
            'E. Я читаю карту, маршрут и время.'
          ] }
        ] },
      { title: 'Огоньки, время и безопасность / Lights, Time and Safety',
        blocks: [
          { type: 'text', text: 'Задание 4 — Математика огоньков.' },
          { type: 'list', items: [
            '5 огоньков × 4 искры = ______ (5 × 4 = 20)',
            '3 печати × 2 звёздочки = ______ (3 × 2 = 6)',
            'Всего: ______ + ______ = ______ (20 + 6 = 26)',
            '24 звёздочки ÷ 6 кармашков = ______ (24 ÷ 6 = 4)'
          ] },
          { type: 'text', text: 'Задание 5 — Время финального квеста. Фразы 8, огоньки 12, паспорт 15, родителю 10.' },
          { type: 'list', items: [
            'Первые две части: 8 + 12 = ______ (20)',
            'Весь квест: 8 + 12 + 15 + 10 = ______ (45 минут)',
            'Если есть 60 минут, останется: ______ (15)',
            'После первых 3 частей осталось: ______ (10)'
          ] },
          { type: 'text', text: 'Задание 6 — Что можно в финальном проекте? Напиши М = можно, Р = спросить родителя, Н = нельзя.' },
          { type: 'list', items: [
            '1. Нарисовать вымышленную карту Нимни. ____',
            '2. Написать настоящий домашний адрес. ____',
            '3. Сделать памятку «как попросить помощи». ____',
            '4. Ввести пароль в ИИ. ____',
            '5. Показать родителю черновик. ____',
            '6. Написать название школы. ____',
            '7. Сделать постер «стоп — уйти — рассказать». ____',
            '8. Попросить родителя помочь проверить. ____',
            '9. Публиковать проект онлайн без взрослого. ____',
            '10. Использовать роли: родитель, учитель, работник места. ____',
            '11. Нарисовать огонёк знаний. ____',
            '12. Добавить фото ребёнка. ____'
          ] }
        ] },
      { title: 'Финальный паспорт / Final Passport',
        blocks: [
          { type: 'text', text: 'Задание 7 — Финальный паспорт квеста.' },
          { type: 'list', items: [
            '1. Огонёк выбора — я умею ____________________.',
            '2. Огонёк безопасности — я знаю ____________________.',
            '3. Огонёк исследователя — я могу ____________________.',
            '4. Огонёк карты и плана — я умею ____________________.',
            '5. Огонёк автора — я могу ____________________.'
          ] },
          { type: 'text', text: 'Нарисуй маленький огонёк: ____________________________________' },
          { type: 'text', text: 'Задание 8 — Правописание. Напиши 6 слов на выбор:' },
          { type: 'list', items: [
            'выбор   карта   план   автор   польза',
            'вывод   ворота   помощь   огонёк   памятка'
          ] },
          { type: 'text', text: 'Задание 9 — Финальные слова. Поставь галочку:' },
          { type: 'list', items: [
            '□ Я умею выбирать.',
            '□ Я умею проверять.',
            '□ Я умею просить помощи.',
            '□ Я умею делать вывод.',
            '□ Я могу сделать полезный материал.'
          ] },
          { type: 'text', text: 'Задание 10 — Обещание автора. Поставь галочку:' },
          { type: 'list', items: [
            '□ Я не только смотрю.',
            '□ Я думаю, проверяю и создаю полезное.',
            '□ Я не пишу личные данные онлайн.',
            '□ Я показываю важное родителю.',
            '□ Я могу сделать хороший шаг сама.'
          ] },
          { type: 'text', text: 'Parent Check: □ Прочитала слова  □ Прочитала фразы  □ Соединила огоньки  □ Решила math quest  □ Проверила safety cards  □ Заполнила паспорт  □ Сказала финальные слова  □ Сказала обещание автора.' },
          { type: 'text', text: 'Notebook Mode — если нет принтера, сделай эти задания в тетради.' }
        ] }
    ]
  },
  parentGuide: {
    goal: 'Анита завершает финальный квест, повторяет главные темы курса и открывает ночную игру.',
    mathGoal: 'Умножение 5 × 4, 3 × 2, сложение, деление 24 ÷ 6, сложение времени и вычитание из 60.',
    russianGoal: 'Прочитать слова выбор, безопасность, исследователь, карта, план, информация, польза, автор, памятка, ворота.',
    readingWritingGoal: 'Прочитать финальные фразы, заполнить паспорт квеста, написать 6 слов.',
    practicalGoal: 'Связать все темы курса в финальную фразу: я умею выбирать, проверять, просить помощи, делать вывод и создавать полезное.',
    parentTheoryCard: {
      title: 'Как провести финальные ворота',
      purpose: 'Помочь родителю завершить курс как праздник пути, а не как экзамен.',
      keyMessage: 'Финальный день показывает ребёнку: «Я прошла путь. Я умею думать, выбирать, проверять и делать полезное.»',
      parentScript: [
        '«Сегодня мы не проверяем тебя строго. Мы собираем огоньки того, чему ты научилась.»',
        '«Ты училась выбирать, быть в безопасности, исследовать, читать карты, планировать и создавать полезное.»',
        '«Ночная игра — это праздничная награда за завершение квеста.»',
        '«Главное — не идеальные ответы, а уверенность: я знаю, что делать.»'
      ],
      practiceSteps: [
        'Прочитайте слова.',
        'Соедините огоньки.',
        'Решите лёгкие задачи.',
        'Заполните паспорт.',
        'Попросите Аниту сказать финальные слова.',
        'Завершите урок и проверьте, что игра открылась.'
      ],
      doNotSay: [
        'Не говорить: «Это экзамен.»',
        'Не сравнивать с Максимом.',
        'Не ругать за ошибки чтения.',
        'Не превращать финал в длинную контрольную.'
      ],
      paperOnlyNotes: [
        'Финальный паспорт можно хранить в папке Нимни.',
        'Можно украсить паспорт наклейкой или рисунком.',
        'Реальные личные данные не писать.'
      ]
    },
    whatThisLessonTeaches: 'Анита собирает весь курс в одну уверенность: я могу думать и действовать.',
    keyMessage: 'Я умею выбирать, проверять, просить помощи, делать вывод и создавать полезное.',
    howToExplain: 'Скажите: «Ты прошла большой путь. Сегодня ты не просто отвечаешь. Ты показываешь, что умеешь пользоваться знаниями.»',
    exampleDialogue:
      'Parent: Что ты умеешь делать теперь?\nChild: Выбирать и проверять.\nParent: Что делать, если страшно или непонятно?\nChild: Просить помощи.\nParent: Что делает автор?\nChild: Делает полезный материал.',
    readingSupport: 'Слова «исследователь», «информация», «памятка» можно читать по частям.',
    russianSpeechGoal: 'Анита говорит финальные слова и обещание автора.',
    mathAnswerKey:
      'math-final-lights: 1) 20. 2) 6. 3) 26. 4) 4.\nmath-final-time: 1) 20. 2) 45. 3) 15. 4) 10.\nfinal-light-match: 1-C, 2-D, 3-A, 4-E, 5-B.\nfinal-safety-author-sort: Можно: 1,3,7,10,11. Спросить родителя: 5,8. Нельзя: 2,4,6,9,12.',
    spellingAnswerKey: 'выбор\nкарта\nплан\nавтор\nпольза\nвывод\nворота\nпомощь\nогонёк\nпамятка',
    answerKey: [
      { taskId: 'reading-review-words', answer: 'Попытка чтения.' },
      { taskId: 'final-gate-reading', answer: 'Попытка чтения.' },
      { taskId: 'final-light-match', answer: '1-C; 2-D; 3-A; 4-E; 5-B.' },
      { taskId: 'math-final-lights', answer: '20; 6; 26; 4.' },
      { taskId: 'math-final-time', answer: '20; 45; 15; 10.' },
      { taskId: 'final-safety-author-sort', answer: 'allowed 1,3,7,10,11; parent 5,8; no 2,4,6,9,12.' },
      { taskId: 'final-quest-passport', answer: 'most stems completed and light drawn.' },
      { taskId: 'spelling-final-gate', answer: 'any 6 attempted words.' },
      { taskId: 'speech-final-gate', answer: 'final words spoken.' },
      { taskId: 'final-author-promise', answer: 'promise read or repeated.' }
    ],
    check: [
      'Анита прочитала слова и фразы.',
      'Анита соединила огоньки.',
      'Анита решила math tasks.',
      'Анита проверила safety cards.',
      'Анита заполнила паспорт.',
      'Анита сказала финальные слова.',
      'Анита сказала обещание автора.',
      'После завершения проверьте открытие ночной игры.'
    ],
    spellingCheck: 'Проверить 6 выбранных слов мягко.',
    readingCheck: 'Главное — попытка чтения и уверенность.',
    practicalCheck: 'Анита должна понимать финальный смысл: я могу думать, проверять и делать полезное.',
    projectCriteria: 'Финальный паспорт содержит 5 огоньков, короткие фразы-окончания и маленький рисунок огонька.',
    rubric:
      'Russian reading attempt — 15 points\nFinal light matching — 15 points\nMath quest — 15 points\nSafety understanding — 15 points\nQuest passport completeness — 20 points\nFinal speech / promise — 10 points\nEffort and focus — 10 points',
    commonMistakes: [
      '«Финал — это экзамен.» Правильно: «Финал — это квест-повторение.»',
      '«Нужно всё идеально.» Правильно: «Нужно постараться и показать путь.»',
      '«Игра — это оплата.» Правильно: «Игра — это праздничный бонус после завершения квеста.»',
      '«Можно написать личные данные в проекте.» Правильно: «Личные данные не пишем онлайн.»'
    ],
    discussionPrompts: [
      'Какой огонёк тебе понравился больше всего?',
      'Что ты теперь умеешь делать лучше?',
      'Где тебе пригодится план?',
      'Какой полезный материал ты можешь сделать сама?'
    ],
    ifEasy: 'Попросите Аниту провести 2-минутную презентацию паспорта по-русски.',
    ifDifficult: 'Оставить только 3 огонька: выбор, безопасность, автор.',
    rewardGuidance: 'Проектный финальный день: базовая награда 5 нимов. Бонусы за чтение, паспорт и финальное обещание.',
    tokenReward: 'Нимы — это призовые токены курса, а не оплата.',
    parentOnlyNotes: 'Ночная игра открывается после завершения финальных ворот. Не называть это оплатой или покупкой.',
    safetyNotes: 'Не вводить личные данные. Не публиковать паспорт онлайн без решения родителя. Игра без рекламы, без личных данных и без покупок.'
  },
  reward: { unit: 'nim', unitName: 'ним', base: 5, max: 8, label: 'Награда за финальный квест', display: '5 нимов',
    bonuses: [
      { id: 'reading-attempt', label: 'Бонус за хорошую попытку русского чтения', amount: 1 },
      { id: 'filled-passport', label: 'Бонус за заполненный финальный паспорт', amount: 1 },
      { id: 'author-promise', label: 'Бонус за финальное обещание автора', amount: 1 }
    ] },
  completionRequirements: {
    requiredTaskIds: ['reading-review-words', 'final-gate-reading', 'final-light-match', 'math-final-lights', 'math-final-time', 'final-safety-author-sort', 'final-quest-passport', 'spelling-final-gate', 'speech-final-gate', 'final-author-promise'],
    allowNotebookCompletion: true
  },
  nextLessonId: 'anita-week-10-night-run'
};

export default day5;
